module.exports = "<div\n    class=\"row\"\n    ng-if=\"CustomFieldsFiltersCtrl.customFields && CustomFieldsFiltersCtrl.customFields.length\"\n>\n    <div class=\"col-md-12\">\n        <span>Pola dodatkowe:</span>\n\n        <form class=\"paramForm\">\n            <im-custom-field-checkbox-filter\n                ng-repeat=\"customField in CustomFieldsFiltersCtrl.customFields\"\n                field=\"customField\"\n            ></im-custom-field-checkbox-filter>\n        </form>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/filters/custom-fields-filters/custom-fields-filters.html
// module id = 540
// module chunks = 0